import React, { FC, useRef, useState } from 'react'
import { CButton } from 'tabs/data/components/CButton'
import { alertError, alertSuccess } from 'api'
import { uploadSchemaReference } from 'tabs/data/api/schemaReference'

const UploadGlyph: FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ verticalAlign: 'middle', marginRight: 8 }}
    aria-hidden="true">
    <path
      d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1663 6.66667L9.99967 2.5L5.83301 6.66667"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10 2.5V12.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const UploadMetadataButton: FC = () => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const [isUploading, setIsUploading] = useState(false)

  const handleClick = () => {
    fileInputRef.current?.click()
  }

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    e.target.value = ''
    if (!file) return

    setIsUploading(true)
    try {
      const response = await uploadSchemaReference(file)
      if (response?.ok) {
        const counts = response.counts
          ? Object.entries(response.counts)
              .map(([k, v]) => `${k}: ${v}`)
              .join(', ')
          : ''
        alertSuccess(`Metadata uploaded (v${response.version || 'n/a'})${counts ? ' — ' + counts : ''}`, 4000)
      } else {
        alertError((response?.errors || ['Upload failed']).join('; '))
      }
    } catch (e: any) {
      alertError(e?.message || 'Something went wrong')
    } finally {
      setIsUploading(false)
    }
  }

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept=".json,application/json"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <CButton color="primary" disabled={isUploading} onClick={handleClick}>
        <UploadGlyph />
        {isUploading ? 'Uploading…' : 'Upload metadata'}
      </CButton>
    </>
  )
}
